function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_22949_31789)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 11.5A2.5 2.5 0 0114.5 9h3a2.5 2.5 0 012.5 2.5v1.766a2.5 2.5 0 01-.9 1.92l-1.74 1.45a1 1 0 00-.36.77V18.8a.2.2 0 01-.2.2h-1.6a.2.2 0 01-.2-.2v-1.395a3 3 0 011.08-2.305l1.74-1.45a.5.5 0 00.18-.384V11.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5v1.3a.2.2 0 01-.2.2h-1.6a.2.2 0 01-.2-.2v-1.3zM15 21.2c0-.11.09-.2.2-.2h1.6c.11 0 .2.09.2.2v1.6a.2.2 0 01-.2.2h-1.6a.2.2 0 01-.2-.2v-1.6z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_22949_31789"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));